import React, { useContext } from 'react'
import { View } from 'oio-react'
import { ArticleNyTimes, Code, Images } from '@phosphor-icons/react'
import PropTypes from 'prop-types'
// import ElementView from 'src/sites/kits/UI/Content/View/Element'
// import { templates, templatePreviews } from 'src/sites/kits/UI/Content/VisualEditor/Templates'
import { templates } from 'src/sites/kits/UI/Content/VisualEditor/Templates'
import customElementTemplate from 'src/sites/kits/UI/Content/VisualEditor/Templates/CustomElement'
import ContentElementEditorContext from 'src/sites/kits/Utils/ContentElementEditor'
import { useMe } from 'src/core/graphql/hooks'

const BlockTemplateChooser = ({ onCreateElement }) => {
   const { insertTemplate } = useContext(ContentElementEditorContext)
   const { me } = useMe()
   const isGatherDeveloper = me?.email.endsWith('@mother.co')

   const handleCreateElement = (templateName) => {
      if (templates[templateName]) {
         insertTemplate(templates[templateName])
         return onCreateElement()
      }

      throw new Error(`Invalid Template: ${templateName}`)
   }

   const handleCreateCustomElement = () => {
      const pathName = window.prompt('Enter Custom Element Path Name')
      insertTemplate(customElementTemplate(pathName))
      return onCreateElement()
   }

   return (
      <View width="100%" height="100%">
         <View
            display="flex"
            alignItems="center"
            justifyContent="center"
            width="100%"
            padding="0px 48px"
            height="96px"
            borderBottom="1px solid #444"
            textAlign="center">
            <View>
               <div className="text-sm font-semibold text-white">
                  Choose a Block template
               </div>
               <div className="text-sm font-medium text-white/50">
                  Add any of the following blocks to your page
               </div>
            </View>
         </View>
         <div className="w-full h-[calc(100%-120px)] p-10 overflow-auto">
            <div className="w-full grid grid-cols-3 gap-6 text-center">
               <button
                  type="button"
                  onClick={() => handleCreateElement('RichText')}
                  className="col-span-1 hover:opacity-70 cursor-pointer">
                  <div className="flex items-center justify-center w-full aspect-[3/2] bg-neutral-700 rounded-lg mb-2">
                     <ArticleNyTimes size={36} color="#888" />
                  </div>
                  <div className="text-sm font-medium text-white">Text</div>
               </button>
               <button
                  type="button"
                  onClick={() => handleCreateElement('Media')}
                  className="col-span-1 hover:opacity-70 cursor-pointer">
                  <div className="flex items-center justify-center w-full aspect-[3/2] bg-neutral-700 rounded-lg mb-2">
                     <Images size={36} color="#888" />
                  </div>
                  <div className="text-sm font-medium text-white">Media</div>
               </button>
               {isGatherDeveloper && (
                  <button
                     type="button"
                     onClick={handleCreateCustomElement}
                     className="col-span-1 hover:opacity-70 cursor-pointer">
                     <div className="flex items-center justify-center w-full aspect-[3/2] bg-neutral-700 rounded-lg mb-2">
                        <Code size={36} color="#888" />
                     </div>
                     <div className="text-sm font-medium text-white">Custom</div>
                  </button>
               )}
            </div>
            {/* <Grid columns="3" spacing="24px">
               {Object.keys(templatePreviews).map(templateName => (
                  <GridCell key={templateName}>
                     <View
                        display="flex"
                        alignItems="flex-end"
                        width="100%"
                        height="100%">
                        <View width="100%">
                           <View
                              float="left"
                              className={css`
                                 &:hover {
                                    opacity: 0.8;
                                 }
                              `}
                              transition="300ms"
                              width="100%"
                              backgroundColor="#fff"
                              padding="12px"
                              style={{ cursor: 'pointer' }}
                              onClick={() => handleCreateElement(templateName)}>
                              <ZoomProvider zoom={0.2}>
                                 <ElementView {...templatePreviews[templateName]} />
                              </ZoomProvider>
                           </View>
                           <View float="left" width="100%" padding="12px" textAlign="center">
                              <Text size="2" weight="medium" color="#fff">
                                 {templateName}
                              </Text>
                           </View>
                        </View>
                     </View>
                  </GridCell>
               ))}
               {isGatherDeveloper && (
                  <GridCell>
                     <View onClick={handleCreateCustomElement}>
                        <View width="100%" padding="30px" backgroundColor="#fff">
                           <Text size="2" weight="medium" color="#333">
                              Custom Element Block
                           </Text>
                        </View>
                     </View>
                  </GridCell>
               )}
            </Grid> */}
         </div>
      </View>
   )
}

BlockTemplateChooser.propTypes = {
   onCreateElement: PropTypes.func.isRequired
}

export default BlockTemplateChooser
